import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { CardComponent } from '@libs/layouts/card';
import { SideNavComponent } from '@libs/layouts/side-nav';

import { LoggedInGuard, LoggedOutGuard } from '@app/common/guards';


export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: '',
    data: {
      fsNav: { root: true },
    },
    children: [
      {
        path: '',
        component: SideNavComponent,
        children: [
          {
            canActivate: [LoggedInGuard],
            path: 'account',
            loadChildren: () => import('./account').then((m) => m.AccountModule),
          },
          {
            canActivate: [LoggedInGuard],
            path: 'admin',
            loadChildren: () => import('./admin').then((m) => m.AdminModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            canActivate: [LoggedInGuard],
            path: 'system',
            loadChildren: () => import('./system').then((m) => m.SystemModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            canActivate: [LoggedInGuard],
            path: 'organization',
            loadChildren: () => import('./environment').then((m) => m.EnvironmentModule),
          },
          {
            canActivate: [LoggedInGuard],
            path: 'terms-privacy',
            loadChildren: () => import('./terms-privacy').then((m) => m.TermsPrivacyModule),
          },
          {
            canActivate: [LoggedInGuard],
            path: 'dashboard',
            loadChildren: () => import('./dashboard').then((m) => m.DashboardModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            canActivate: [LoggedInGuard],
            path: 'staff',
            loadChildren: () => import('./staff').then((m) => m.StaffModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            path: 'notfound',
            loadChildren: () => import('@libs/not-found').then((m) => m.NotFoundModule),
          },
        ],
      },
    ],
  },
  {
    path: '',
    component: CardComponent,
    canActivate: [LoggedOutGuard],
    children: [
      {
        path: 'password',
        loadChildren: () => import('./password/password.module').then((m) => m.PasswordModule),
        data: { bodyClass: 'body-card body-password' },
      },
      {
        path: 'invite',
        loadChildren: () => import('./invite/invite.module').then((m) => m.InviteModule),
        data: { bodyClass: 'body-card' },
      },
      {
        path: 'signin',
        loadChildren: () => import('./signin').then((m) => m.SigninModule),
        data: { bodyClass: 'body-card body-signin' },
      },
    ],
  },
  {
    path: 'blank',
    component: CardComponent,
  },
  { path: '**', redirectTo: '/notfound' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        useHash: (+document.location.port === 8080 || document.location.protocol === 'file:'),
        preloadingStrategy: PreloadAllModules,
        relativeLinkResolution: 'legacy',
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
